import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/add-plus-circle.svg'
import _imports_1 from '../../assets/edit-pencil-technical.svg'
import _imports_2 from '../../assets/trash-icoon.svg'
import _imports_3 from '../../assets/checkmark-paper.svg'


const _hoisted_1 = { class: "flex w-full h-[calc(100vh-52px)]" }
const _hoisted_2 = { class: "max-w-[934px] pt-[24px] w-full mx-auto h-full" }
const _hoisted_3 = { class: "flex h-full flex-col" }
const _hoisted_4 = { class: "w-full flex justify-between mb-[12px]" }
const _hoisted_5 = { class: "h-[44px] flex items-center justify-center" }
const _hoisted_6 = { class: "text-[20px] font-semibold text-[#393840]" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col overflow-y-auto pb-6"
}
const _hoisted_8 = { class: "w-full h-[41px] flex items-center justify-start p-[4px] bg-[#E5E4E2] rounded-[7px] mb-[8px]" }
const _hoisted_9 = { class: "text-[12px] font-semibold px-[4px] text-[#393840]" }
const _hoisted_10 = { class: "flex flex-col h-full gap-2 overflow-y-auto" }
const _hoisted_11 = { class: "p-[4px]" }
const _hoisted_12 = { class: "text-[14px] text-[#393840]" }
const _hoisted_13 = { class: "flex items-center justify-end p-[4px]" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 1,
  class: "h-full flex items-center justify-center"
}
const _hoisted_17 = { class: "flex flex-col items-center" }
const _hoisted_18 = { class: "text-[16px] font-medium text-[#898790]" }

import { ref, onMounted } from "vue";
import MainLayout from "@/layouts/MainLayout.vue";
import BonusReportDialog from "@/components/installer/BonusReportDialog.vue";
import DeleteReportConfirmDialog from "@/components/installer/DeleteReportConfirmDialog.vue";
import InstallersSidemenu from "@/components/Sidebar/installer/InstallersSidemenu.vue";
import client from "@/utils/axios";
import { useTranslate } from "@/composables/useTranslate";
import SecondaryPageHeader from "@/components/PageHeader/SecondaryPageHeader.vue";
import { MonthlyBonus, Worker } from "@/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'MonthlyBonusView',
  setup(__props) {

const isReportDialogOpen = ref<boolean>(false);
const isDeleteDialogOpen = ref<boolean>(false);
const isEdit = ref<boolean>(false);
const bonusDate = ref<MonthlyBonus | null>(null);
const monthlyBonusList = ref<MonthlyBonus[]>([]);

const workers = ref<Worker[]>([]);
const selectedWorker = ref<string | null>(null);
const selectedMonths = ref<Record<string, string>>({});
const isLoading = ref<boolean>(false);
const month = ref<number | null>(null);
const year = ref<number | null>(null);

const { t } = useTranslate();

const openDialog = () => {
  bonusDate.value = null;
  month.value = null;
  year.value = null;
  isReportDialogOpen.value = true;
  isEdit.value = false;
};

const openDialogEdit = (bonus: MonthlyBonus) => {
  bonusDate.value = bonus;
  month.value = bonus.monthNumber;
  year.value = bonus.year;
  isReportDialogOpen.value = true;
  isEdit.value = true;
};

const openDelete = (bonus: MonthlyBonus) => {
  bonusDate.value = bonus;
  isDeleteDialogOpen.value = true;
};

// Refs

// Functions
const getAllInstallers = async () => {
  isLoading.value = true;
  try {
    const response = await client.get("/installers");
    workers.value = response.data;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

const handleSelectWorker = (workerId: string) => {
  if (selectedWorker.value === workerId) {
    selectedWorker.value = null;
  } else {
    selectedWorker.value = workerId;

    if (!selectedMonths.value[workerId]) {
      selectedMonths.value[workerId] = "Current month";
    }
  }
};

const getAllReports = async () => {
  try {
    const response = await client.get("/installers/monthly-bonus/report");

    monthlyBonusList.value = response.data
      .map((item: MonthlyBonus) => ({
        ...item,
        monthNumber: item.month,
        month: t(`months.${item.month}`).value, // convert number to month name
      }))
      .sort((a: any, b: any) => {
        // first sort by year, then by original numeric month
        return a.year - b.year || a.month - b.month;
      });
  } catch (error) {
    console.log(error);
  }
};

const handleSelectMonth = (workerId: string, month: string) => {
  selectedMonths.value[workerId] = month;
};

const closeReport = () => {
  isReportDialogOpen.value = false;
  getAllReports();
};

const closeDelete = () => {
  isDeleteDialogOpen.value = false;
  getAllReports();
};

// Lifecycle hooks
onMounted(() => {
  getAllInstallers();
  getAllReports();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MainLayout, null, {
    default: _withCtx(() => [
      (isReportDialogOpen.value)
        ? (_openBlock(), _createBlock(BonusReportDialog, {
            key: 0,
            "is-report-dialog-open": isReportDialogOpen.value,
            "is-edit": isEdit.value,
            "bonus-date": bonusDate.value,
            month: String(month.value),
            year: year.value,
            onOnClose: closeReport
          }, null, 8, ["is-report-dialog-open", "is-edit", "bonus-date", "month", "year"]))
        : _createCommentVNode("", true),
      _createVNode(DeleteReportConfirmDialog, {
        "is-delete-dialog-open": isDeleteDialogOpen.value,
        "bonus-date": bonusDate.value,
        onOnClose: closeDelete
      }, null, 8, ["is-delete-dialog-open", "bonus-date"]),
      _createVNode(SecondaryPageHeader, { "is-monthly-bonus": true }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(InstallersSidemenu, {
          workers: workers.value,
          "selected-worker": selectedWorker.value,
          "selected-months": selectedMonths.value,
          onSelectWorker: handleSelectWorker,
          onSelectMonth: handleSelectMonth
        }, null, 8, ["workers", "selected-worker", "selected-months"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)("installers.monthly_bonus")), 1)
              ]),
              _createElementVNode("button", {
                onClick: openDialog,
                class: "flex items-center p-[12px] gap-[8px] text-[16px] text-white font-semibold bg-[#393840] rounded-[7px]"
              }, [
                _cache[0] || (_cache[0] = _createElementVNode("img", {
                  class: "h-[18px] w-[18px] text-white",
                  src: _imports_0,
                  alt: ""
                }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_unref(t)("installers.report_monthly_bonus")), 1)
              ])
            ]),
            (monthlyBonusList.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)("installers.period")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthlyBonusList.value, (bonus, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${bonus?.month}-${bonus.year}-${index}`,
                        class: "p-[4px] flex justify-between bg-white rounded-[7px]"
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("p", _hoisted_12, _toDisplayString(bonus.month ? bonus.month?.trim() : "") + "/" + _toDisplayString(bonus.year), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("img", {
                            class: "w-[16px] h-[16px] cursor-pointer",
                            src: _imports_1,
                            alt: "",
                            onClick: ($event: any) => (openDialogEdit(bonus))
                          }, null, 8, _hoisted_14),
                          _createElementVNode("img", {
                            class: "w-[16px] h-[16px] ml-[10px] cursor-pointer",
                            src: _imports_2,
                            alt: "",
                            onClick: ($event: any) => (openDelete(bonus))
                          }, null, 8, _hoisted_15)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _cache[1] || (_cache[1] = _createElementVNode("img", {
                      class: "w-[128px] h-[128px] mb-[8px]",
                      src: _imports_3,
                      alt: ""
                    }, null, -1)),
                    _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(t)("installers.no_reports_yet")), 1)
                  ])
                ]))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})